import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { appTheme } from './app/theme';
import { resolver } from './app/resolver';
import { oauthGoogleClientId } from '@shared/config/runtime';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './app/global.css';

function handleOAuthPopupCallback() {
  const provider = window.location.pathname.split('/').pop();
  if (!['google', 'twitter'].includes(provider || '') || !window.opener) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  window.opener.postMessage(provider === 'google' ? {
    type: 'LOCS_OAUTH_GOOGLE_CALLBACK',
    idToken: fragment.get('id_token'),
    state: fragment.get('state') || params.get('state'),
    error: fragment.get('error') || params.get('error'),
  } : {
    type: 'LOCS_OAUTH_TWITTER_CALLBACK',
    code: params.get('code'), state: params.get('state'), error: params.get('error'),
  }, window.location.origin);
  window.close();
  return true;
}

const googleClientId = oauthGoogleClientId || 'locs-oauth-not-configured.apps.googleusercontent.com';

const app = (
  <StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <MantineProvider theme={appTheme} cssVariablesResolver={resolver} defaultColorScheme="auto">
        <Notifications
          position="bottom-right"
          containerWidth={360}
          transitionDuration={180}
          styles={{
            notification: {
              border: '1px solid var(--locs-border-faint)',
              borderRadius: 14,
              background: 'var(--locs-panel)',
              boxShadow: '0 12px 30px rgba(27, 18, 11, 0.14)',
              padding: '14px 16px',
            },
          }}
        />
        <App />
      </MantineProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);

if (!handleOAuthPopupCallback()) {
  createRoot(document.getElementById('root')!).render(app);
}
